// flickity Slider
$(function () {

    // =========================
    // SINGLE SLIDER
    // =========================
    if ($('.singleSlider').length > 0) {

        var $singleSlider = $('.singleSlider').flickity({
            cellAlign: 'left',
            wrapAround: true,
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            imagesLoaded: true,
            adaptiveHeight: true,
            draggable: true,
            autoPlay: 5000
        });

        // Autoplay first slide
        playVideoInActiveSlide($singleSlider);

        // On slide change
        $singleSlider.on('change.flickity', function () {
            playVideoInActiveSlide($singleSlider);
        });
    }

    function playVideoInActiveSlide($slider) {

        // Pause only videos inside this slider
        $slider.find('video').each(function () {
            this.pause();
            this.currentTime = 0;
            this.style.display = "none";
        });

        $slider.find('.poster, .banner-poster').show();
        $slider.find('.play-btn').show();

        var $activeSlide = $slider.find('.is-selected');

        var video   = $activeSlide.find('video')[0];
        var poster  = $activeSlide.find('.poster, .banner-poster')[0];
        var playBtn = $activeSlide.find('.play-btn')[0];

        if (video) {
            video.muted = true;
            video.setAttribute('playsinline', '');

            if (poster) poster.style.display = "none";
            if (playBtn) playBtn.style.display = "none";

            video.style.display = "block";

            video.play().catch(function () {
                console.log("Autoplay blocked");
            });
        }
    }


    // =========================
    // GROUP SLIDER
    // =========================
    if ($('.groupSlider').length > 0) {
        $('.groupSlider').each(function () {
            $(this).flickity({
                cellAlign: 'center',
                wrapAround: false,
                groupCells: true,
                contain: true,
                pageDots: true,
                prevNextButtons: true,
                imagesLoaded: true,
                adaptiveHeight: true,
                draggable: true,
                freeScroll: false,
                touchVerticalScroll: true
            });
        });
    }


    // Thumbnail Slider
    $('.thumbnailSlider').each(function(){
        var scope = $(this);

        // MAIN SLIDER
        var $slider = scope.find('.larg-slider').flickity({
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            imagesLoaded: true,
        });

        window.addEventListener('pageshow', function() {
            $slider.flickity('resize');
            $slider.flickity('reposition');
        });

        // CLICK THUMB
        scope.find('.thumb').on('click', function(){

            var index = $(this).index();

            $slider.flickity('select', index);

            setActiveThumb(index);

        });

        // ON SLIDE CHANGE
        $slider.on('change.flickity', function(event, index){

            setActiveThumb(index);

        });

        // ACTIVE + AUTO SCROLL
        function setActiveThumb(index){

            scope.find('.thumb').removeClass('active');

            var $active = scope.find('.thumb').eq(index);

            $active.addClass('active');

            // AUTO HORIZONTAL SCROLL
            const container = scope.find('.thumb-scroll')[0];

            const activeLeft = $active[0].offsetLeft;
            const activeWidth = $active.outerWidth();

            container.scrollTo({
                left: activeLeft - (container.offsetWidth / 2) + (activeWidth / 2),
                behavior: 'smooth'
            });

        }

    });

});

